import { z } from 'zod';

const EnvSchema = z.object({
  VITE_EDCI_AUTH_URL: z.string().url().min(1),
  VITE_EDCI_API_URL: z.string().url().min(1),
  VITE_APP_KEY: z.string().min(1),
  VITE_LOG_LEVEL: z.enum(['fatal', 'error', 'warn', 'info', 'debug', 'trace']).default('info'),
  VITE_SEQ_URL: z.string().url().optional(),
  VITE_SEQ_API_KEY: z.string().optional(),
  VITE_SEQ_APPLICATION_NAME: z.string().default('ReplicaCloud-Migrator-UI'),
  VITE_SEQ_ENVIRONMENT: z.string().default('development'),
  VITE_SEQ_LOGGING_THRESHOLD: z.coerce.number().default(0)
});

type Env = z.infer<typeof EnvSchema>;

let cached: Env | null = null;

export function getEnv(): Env {
  if (cached) return cached;
  const raw: Record<string, unknown> = {
    VITE_EDCI_AUTH_URL: import.meta.env.VITE_EDCI_AUTH_URL,
    VITE_EDCI_API_URL: import.meta.env.VITE_EDCI_API_URL,
    VITE_APP_KEY: import.meta.env.VITE_APP_KEY,
    VITE_LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL,
    VITE_SEQ_URL: import.meta.env['VITE_SEQ_URL'],
    VITE_SEQ_API_KEY: import.meta.env['VITE_SEQ_API_KEY'],
    VITE_SEQ_APPLICATION_NAME: import.meta.env['VITE_SEQ_APPLICATION_NAME'],
    VITE_SEQ_ENVIRONMENT: import.meta.env['VITE_SEQ_ENVIRONMENT'],
    VITE_SEQ_LOGGING_THRESHOLD: import.meta.env['VITE_SEQ_LOGGING_THRESHOLD']
  };
  const parsed = EnvSchema.safeParse(raw);
  if (!parsed.success) {
    // eslint-disable-next-line no-console
    console.error('Environment validation failed', parsed.error.flatten().fieldErrors);
    throw new Error('Invalid environment configuration');
  }
  cached = parsed.data;
  return cached;
}

export type { Env };
